var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Report__Entity" },
    [
      _c("Entity", {
        ref: "entity",
        attrs: {
          "entity-type": "Report",
          "entity-id": _vm.verdictId,
          innerComponent: _vm.innerComponent,
          innerComponentTitle: "עריכת מקבץ פסיקה",
          title: "וידאו",
          "back-button-text": "רשימת יחידות לימוד",
          "back-button-url": "lessons",
          widgets: _vm.widgets,
          actions: _vm.actions,
          preview: _vm.preview,
          "read-only": _vm.readOnly,
          entityReady: _vm.entityReady,
          activities: [],
        },
        on: { onFormSave: _vm.onFormSave, onFormDiscard: _vm.onFormDiscard },
        scopedSlots: _vm._u([
          {
            key: "mandatory",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("מספר מזהה למקבץ פסיקה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.verdictId))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("יחידת לימוד:"),
                    ]),
                    _c(
                      "a",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value link value has-text-weight-bold",
                        on: { click: _vm.openLessonPage },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.lessonId) + " - " + _vm._s(_vm.lessonName)
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }